import { relativeUrl } from '../utils/url.ts';

export interface PopStateInterceptor {
  /**
   * Should the current pop state event be interrupted?
   */
  shouldPopStateCancel(): boolean;

  /**
   * This interceptor has prevented the last pop state event.
   */
  popStateCancelled(): void;
}

export class HistoryService {
  private popStateInterceptor: PopStateInterceptor[] = [];

  constructor() {
    window.addEventListener('popstate', this.historyPopStateListener);
  }

  public addPopStateInterceptor(interceptor: PopStateInterceptor): void {
    this.popStateInterceptor.push(interceptor);
  }

  public removePopStateInterceptor(interceptor: PopStateInterceptor): void {
    this.popStateInterceptor = this.popStateInterceptor.filter(i => i !== interceptor);
  }

  private historyPopStateListener = (event: PopStateEvent) => {
    event.preventDefault();
    this.handlePopState();
  };

  private async handlePopState(): Promise<void> {
    // is there an interceptor hijacking the popstate?
    const popStateCancellation = this.popStateInterceptor.find(interceptor =>
      interceptor.shouldPopStateCancel()
    );

    // yes. don't pop the state and let the interceptor control what to do next
    if (popStateCancellation) {
      // re-add the popped history state
      window.history.pushState(undefined, document.title, relativeUrl());

      popStateCancellation?.popStateCancelled();
    }
  }
}
